import { Controller } from "@hotwired/stimulus";

export default class extends Controller {

  connect() {
  }

  submit(event) {
    if (!$('#link-search').length) {
      $('#portfolio-tabs').prepend(`<li id="link-search" class="nav-item"> <a class="nav-link" data-toggle="tab" href="#tab-search">Search Results</a></li>`);
      $('a[href="#tab-search"]').tab('show');
      $('#tab-search').html("<p class='empty'>Loading ...</p>");
    }
    $('a[href="#tab-search"]').tab('show');
  }
}
